import { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function Settings() {
  const { user } = useAuth();
  const [pw, setPw] = useState({ current:'', next:'', confirm:'' });
  const [saving, setSaving] = useState(false);

  const changePw = async e => {
    e.preventDefault();
    if (pw.next !== pw.confirm) return toast.error('Passwords do not match');
    if (pw.next.length < 8) return toast.error('Password must be at least 8 characters');
    setSaving(true);
    try {
      await axios.put('/api/auth/change-password', { currentPassword: pw.current, newPassword: pw.next });
      toast.success('Password changed!');
      setPw({ current:'', next:'', confirm:'' });
    } catch (err) { toast.error(err.response?.data?.error || 'Failed'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="page-header">
        <div><h1>Settings</h1><p>Manage your account</p></div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20, maxWidth:900 }}>
        {/* Profile */}
        <div className="card">
          <h3 style={{ fontSize:16, fontWeight:700, marginBottom:20 }}>Profile</h3>
          <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:24 }}>
            <div style={{ width:60, height:60, borderRadius:'50%', background:'linear-gradient(135deg,#0057FF,#00D4FF)', color:'#fff', fontSize:24, fontWeight:800, display:'flex', alignItems:'center', justifyContent:'center' }}>
              {user?.name?.charAt(0)}
            </div>
            <div>
              <div style={{ fontWeight:700, fontSize:16 }}>{user?.name}</div>
              <div style={{ color:'var(--slate)', fontSize:13 }}>{user?.email}</div>
              <div style={{ color:'var(--slate)', fontSize:12, textTransform:'capitalize', marginTop:2 }}>Role: {user?.role}</div>
            </div>
          </div>
          <div style={{ background:'var(--surface)', borderRadius:10, padding:'12px 16px', fontSize:13, color:'var(--gray)' }}>
            To update your name or email, contact a Super Admin.
          </div>
        </div>

        {/* Change Password */}
        <div className="card">
          <h3 style={{ fontSize:16, fontWeight:700, marginBottom:20 }}>Change Password</h3>
          <form onSubmit={changePw}>
            {[['current','Current Password'],['next','New Password'],['confirm','Confirm New Password']].map(([k,l]) => (
              <div className="form-field" key={k}>
                <label>{l}</label>
                <input className="form-control" type="password" required value={pw[k]}
                  onChange={e => setPw({ ...pw, [k]: e.target.value })} />
              </div>
            ))}
            <button type="submit" className="btn btn--primary" disabled={saving} style={{ marginTop:4 }}>
              {saving ? 'Updating…' : 'Update Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
